import AllRequestsSVG from "../../../SharedComponents/assets/icons/svg/AllRequestsSVG";
import BellIconSVG from "../../../SharedComponents/assets/icons/svg/BellIconSVG";
import HelpIconSVG from "../../../SharedComponents/assets/icons/svg/HelpIconSVG";
import HomeIconSVG from "../../../SharedComponents/assets/icons/svg/HomeIconSVG";
import MessagesIconSVG from "../../../SharedComponents/assets/icons/svg/MessagesIconSVG";
import MessagesLetterIconSVG from "../../../SharedComponents/assets/icons/svg/MessagesLetterIconSVG";
import SecurityIconSVG from "../../../SharedComponents/assets/icons/svg/SecurityIconSVG";
import TermsIconSVG from "../../../SharedComponents/assets/icons/svg/TermsIconSVG";
import CircledImage from "../../../SharedComponents/components/ImageComponents/CircledImage";


//TODO - Define the routes and implement routing to the target page
export const sidebarLinksData = [
    {
        icon: (color) => HomeIconSVG(color),
        name: 'Početak',
        href: "/home"
    },
    {
        icon: (color) => AllRequestsSVG(color),
        name: "Svi zahtevi",
        href: "/all-requests",
    },
    {
        icon: (color) => MessagesIconSVG(color),
        name: "Poruke",
        href: "/messages",
    },
    {
        icon: (color) => BellIconSVG(color),
        name: "Obaveštenja",
        href: "/notifications",
    },
];


export const bottomSidebarLinksData = [
    {
        icon: (color) => HelpIconSVG(color),
        name: "Pomoć",
        href: ""
    },
    {
        icon: (color) => MessagesLetterIconSVG(color),
        name: "Pišite nam",
        href: ""
    },
    {
        icon: (color) => TermsIconSVG(color),
        name: "Uslovi korišćenja",
        href: ""
    },
    {
        icon: (color) => SecurityIconSVG(color),
        name: "Zaštita podataka",
        href: ""
    },
    {
        icon: (source) => CircledImage(source),
        name: "Nalog",
        href: ""
    }
]